const SideTypeList = ['privacy', 'wallet', 'userProfile', 'updatePassword', 'shippingAddress', 'updateAccount', 'securitySetting']
const KeycloakSideTypeList = []

export default SideTypeList
export { KeycloakSideTypeList }
